<template>
  <DetailCard v-if="externalServicesEnabled" :loading="showSpinnerMain" class="mb-4">
    <template #heading>
      <span class="pi pi-shopping-bag"></span>
      {{ $t(`messages.detailRealEstateTitle`) }}
    </template>

    <template #controls>
      <ProgressSpinner v-if="showSpinnerItem" class="ml-auto mb-0" small></ProgressSpinner>
    </template>

    <div class="grid">
      <div class="col-12">
        <Button
          v-for="row in data"
          :key="row.registriosa_nr"
          :severity="row['registriosa_nr'] === realEstateId ? 'success' : null"
          v-tooltip.bottom="'registriosa: ' + row.registriosa_nr"
          size="small"
          class="mr-1 mb-1"
          @click="selectRealEstate(row.registriosa_nr, row.korteri_nr)"
        >
          krt. {{ row['korteri_nr'] }}
        </Button>
      </div>
    </div>

    <div
      v-if="
        !selectedPart1Entries ||
        !selectedPart2Entries ||
        !selectedPart3Entries ||
        !selectedPart4Entries
      "
      class="flex justify-center mt-3"
    >
      <div class="p-buttonset">
        <Button class="m-1" outlined @click="loadRealEstatePart1234(1)">
          Lae jaod 1, 2, 3, 4 (3€)
        </Button>
        <Button
          v-if="!selectedPart1Main || !selectedPart1Entries"
          :disabled="dataDetailSaved['REAL_ESTATE_DETAIL_1']"
          outlined
          class="m-1"
          @click="loadRealEstatePart1(1)"
        >
          Lae jagu 1(1€)
        </Button>
        <Button
          v-if="!selectedPart2Entries"
          :disabled="dataDetailSaved['REAL_ESTATE_DETAIL_2']"
          outlined
          class="m-1"
          @click="loadRealEstatePart2(1)"
        >
          Lae jagu 2 (1€)
        </Button>
        <Button
          v-if="!selectedPart3Entries"
          :disabled="dataDetailSaved['REAL_ESTATE_DETAIL_34']"
          outlined
          class="m-1"
          @click="loadRealEstatePart34(1)"
        >
          Lae jagu 3 (1€)
        </Button>
        <Button
          v-if="!selectedPart4Entries"
          :disabled="dataDetailSaved['REAL_ESTATE_DETAIL_34']"
          outlined
          class="m-1"
          @click="loadRealEstatePart34(1)"
        >
          Lae jagu 4 (1€)
        </Button>
      </div>
    </div>

    <div v-if="realEstateGeneral && realEstateGeneral.kinnistu_registriosa_number" class="mt-3">
      <div class="flex justify-center my-3">
        <h2>Korter: {{ realEstateNr }}, registriosa nr: {{ realEstateId }}</h2>
      </div>
      <DataTable v-if="realEstateGeneral" class="p-datatable-sm">
        <Column field="label" header="Väli"></Column>
        <Column field="value" header="Väärtus"></Column>
        <template #body>
          <Row>
            <Column>Registriosa number</Column>
            <Column>{{ realEstateGeneral.kinnistu_registriosa_number }}</Column>
          </Row>
          <Row>
            <Column>Kinnistusosakond</Column>
            <Column>{{ realEstateGeneral.kinnistu_kinnistusosakond }}</Column>
          </Row>
          <Row>
            <Column>Liik</Column>
            <Column>{{ realEstateGeneral.kinnistu_liik }}</Column>
          </Row>
          <Row>
            <Column>Eriomand</Column>
            <Column>{{ realEstateNr }}</Column>
          </Row>
          <Row>
            <Column>Õigsuse märge</Column>
            <Column>{{ realEstateGeneral.kinnistu_oigsuse_marge }}</Column>
          </Row>
          <Row>
            <Column>Digitoimik</Column>
            <Column>{{ realEstateGeneral.kinnistu_digitaalne_toimik }}</Column>
          </Row>
        </template>
      </DataTable>
    </div>

    <Card
      v-if="realEstateId && selectedPart1Main && selectedPart1Entries"
      title="Jagu 1: Kinnistu koosseis"
      class="mt-3"
    >
      <DataTable v-if="selectedPart1Main" :value="selectedPart1Main" size="small" stripedRows>
        <Column field="jagu1-kande-nr" header="Kande nr"></Column>
        <Column field="jagu1-tunnus" header="Katastritunnus"></Column>
        <Column field="jagu1-sihtotstarve" header="Sihtotstarve ja asukoht"></Column>
        <Column field="jagu1-pindala" header="Pindala">
          <template #body="slotProps">
            <span v-html="slotProps.data['jagu1-pindala']"></span>
          </template>
        </Column>
        <Column field="jagu1-kande-tekst" header="Info"></Column>
        <Column field="jagu1-kehtivus" header="Kande kehtivus"></Column>
      </DataTable>
      <DataTable
        v-if="selectedPart1Entries"
        :value="selectedPart1Entries"
        size="small"
        class="mt-3"
        stripedRows
      >
        <Column field="jagu1-rida-kande-nr" header="Kande nr"></Column>
        <Column field="jagu1-rida-kande-tekst" header="Kande tekst"></Column>
        <Column field="jagu1-rida-kande-alus" header="Kande alus"></Column>
        <Column field="jagu1-rida-kehtivus" header="Kehtivus"></Column>
      </DataTable>
    </Card>

    <Card v-if="realEstateId && selectedPart2Entries" title="Jagu 2: omanik" class="mt-3">
      <DataTable :value="selectedPart2Entries" size="small" stripedRows>
        <Column field="jagu2-kande-nr" header="Kande nr"></Column>
        <Column field="jagu2-omanik" header="Omanik">
          <template #body="slotProps">
            <p v-for="item in slotProps.data['jagu2-omanik']" :key="item">
              {{ item }}
            </p>
          </template>
        </Column>
        <Column field="jagu2-kande-alus" header="Kande alus"></Column>
        <Column field="jagu2-kehtivus" header="Kande kehtivus"></Column>
      </DataTable>
    </Card>

    <Card
      v-if="realEstateId && selectedPart3Entries"
      title="Jagu 3: koormatised, kitsendused (+Jagu 4)"
      class="mt-3"
    >
      <DataTable :value="selectedPart3Entries" size="small" stripedRows>
        <Column field="jagu3-kande-nr" header="Kande nr"></Column>
        <Column
          field="jagu3-kande-tekst"
          header="Kinnistut koormavad piiratud asjaõigused (v.a. hüpoteegid) ja märked; käsutusõiguse kitsendused"
        ></Column>
        <Column
          field="jagu3-kande-alus"
          header="Märked piiratud asjaõiguste kohta, kannete muudatused ja kustutamised"
        ></Column>
        <Column field="jagu3-kehtivus" header="Kande kehtivus"></Column>
      </DataTable>
    </Card>

    <Card
      v-if="realEstateId && selectedPart4Entries"
      title="Jagu 4: hüpoteegid (+Jagu 3)"
      class="mt-3"
    >
      <DataTable :value="selectedPart4Entries" size="small" stripedRows>
        <Column field="jagu4-kande-nr" header="Kande nr"></Column>
        <Column field="jagu4-kande-tekst" header="Hüpoteegid"></Column>
        <Column field="jagu4-summa" header="Hüpoteegi summa"></Column>
        <Column
          field="jagu4-kande-alus"
          header="Märked hüpoteekide kohta, kannete muudatused ja kustutamised"
        ></Column>
        <Column field="jagu4-kehtivus" header="Kande kehtivus"></Column>
      </DataTable>
    </Card>
  </DetailCard>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { onMounted, ref, watch } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { useDetailStore } from '@/stores/useDetailStore'
import DetailCard from '../DetailCard.vue'

const store = useDetailStore()
const {
  cadasterId,
  ehrId,
  realEstateGeneral,
  realEstatePart1Main,
  realEstatePart1Entries,
  realEstatePart2,
  realEstatePart3,
  realEstatePart4,
} = storeToRefs(store)

const emit = defineEmits(['real-estate-no', 'real-estate-owner'])

const externalServicesEnabled = ref(false)
const showSpinnerMain = ref(false)
const showSpinnerItem = ref(false)
const realEstateId = ref(null)
const realEstateNr = ref(null)
const selectedPart1Main = ref([])

const selectedPart1Entries = ref([])
const selectedPart2Entries = ref([])
const selectedPart3Entries = ref([])
const selectedPart4Entries = ref([])

const data = ref([])
const dataDetailSaved = ref([])
const dataUserBilling = ref(0)

watch(
  () => cadasterId.value,
  () => {
    loadRealEstateData()
  },
)

onMounted(() => {
  initRealEstateData()
})

const loadRealEstateData = async () => {
  // RED-220: source the `external-services` permission from Inertia-shared
  // `auth.can` instead of fetching /api/admin/user/permissions on every
  // mount. The HandleInertiaRequests middleware now exposes this key.
  const canExternal = !!usePage().props?.auth?.can?.['external-services']
  if (!canExternal) {
    return
  }

  externalServicesEnabled.value = true

  // An evaluation without a cadaster number has nothing to look up: the store
  // settles `cadasterId` on '' and the watcher still lands here, and the
  // request would go out as `/api/real-estate/` and 404 in the console.
  if (!cadasterId.value) {
    return
  }

  showSpinnerMain.value = true

  await axios
    .get(
      '/api/real-estate/' +
        cadasterId.value +
        '?service=REAL_ESTATE_OBJECTS&force=1',
    )
    .then(response => {
      data.value = response.data
    })
    .catch(err => {
      console.log('selectedPart1FieldsEntries error: ' + err)
    })
    .finally(() => {
      showSpinnerMain.value = false
    })
}

const selectRealEstate = (realEstateId, realEstateNr) => {
  realEstateNr.value = realEstateNr
  realEstateId.value = realEstateId

  if (realEstateId !== undefined) {
    emit('real-estate-no', realEstateId)
  }
  loadRealEstatePart1234(0)
}

const loadRealEstatePart1 = force => {
  if (realEstateId.value === undefined) {
    return
  }

  showSpinnerItem.value = true
  axios
    .get(
      '/api/real-estate/' +
        realEstateId.value +
        '?service=REAL_ESTATE_DETAIL_1&force=' +
        force +
        '&ehrid=' +
        ehrId.value,
    )
    .then(response => {
      selectedPart1Main.value = response.data.main
      selectedPart1Entries.value = response.data.entries

      realEstatePart1Main.value = selectedPart1Main.value
      realEstatePart1Entries.value = selectedPart1Entries.value
      resolveRealEstateGeneral(response.data.general)
    })
    .catch(err => {
      console.log('loadRealEstatePart1 error: ' + err)
    })
    .finally(() => {
      showSpinnerItem.value = false
    })
}

const loadRealEstatePart2 = force => {
  if (realEstateId.value === undefined) {
    return
  }

  axios
    .get(
      '/api/real-estate/' +
        realEstateId.value +
        '?service=REAL_ESTATE_DETAIL_2&force=' +
        force +
        '&ehrid=' +
        ehrId.value,
    )
    .then(response => {
      if (response.data.length === 0) {
        initRealEstateData()
        selectedPart2Entries.value = undefined
        return
      }
      selectedPart2Entries.value = response.data.entries
      realEstatePart2.value = response.data.entries
      resolveRealEstateGeneral(response.data.general)
      realEstateOwnerChanged(response.data.entries[0]['jagu2-omanik'])
    })
    .catch(err => {
      console.log('loadRealEstatePart2 error: ' + err)
    })
}

const loadRealEstatePart34 = force => {
  if (realEstateId.value === undefined) {
    return
  }
  axios
    .get(
      '/api/real-estate/' +
        realEstateId.value +
        '?service=REAL_ESTATE_DETAIL_34&force=' +
        force +
        '&ehrid=' +
        ehrId.value,
    )
    .then(response => {
      selectedPart3Entries.value = response.data.part3
      selectedPart4Entries.value = response.data.part4

      realEstatePart3.value = selectedPart3Entries.value
      realEstatePart4.value = selectedPart4Entries.value
      resolveRealEstateGeneral(response.data.general)
    })
    .catch(err => {
      console.log('loadRealEstatePart1 error: ' + err)
    })
}

const loadRealEstatePart1234 = force => {
  if (realEstateId.value === undefined) {
    return
  }
  axios
    .get(
      '/api/real-estate/' +
        realEstateId.value +
        '?service=REAL_ESTATE_DETAIL_1234&force=' +
        force +
        '&ehrid=' +
        ehrId.value,
    )
    .then(response => {
      if (response.data.part1.length === 0) {
        loadRealEstatePart1(0)
        loadRealEstatePart2(0)
        loadRealEstatePart34(0)
      } else {
        selectedPart1Main.value = response.data.part1.main
        selectedPart1Entries.value = response.data.part1.entries
        selectedPart2Entries.value = response.data.part2.entries
        selectedPart3Entries.value = response.data.part3
        selectedPart4Entries.value = response.data.part4

        realEstatePart1Main.value = selectedPart1Main.value
        realEstatePart1Entries.value = selectedPart1Entries.value
        realEstatePart2.value = selectedPart2Entries.value
        realEstatePart3.value = selectedPart3Entries.value
        realEstatePart4.value = selectedPart4Entries.value
        resolveRealEstateGeneral(response.data.part1.general)
        realEstateOwnerChanged(selectedPart2Entries.value[0]['jagu2-omanik'])
      }
    })
    .catch(err => {
      console.log('loadRealEstatePart1 error: ' + err)
    })
}

const resolveRealEstateGeneral = input => {
  if (input !== undefined) {
    realEstateGeneral.value = input
  } else {
    initRealEstateData()
  }
}

const realEstateOwnerChanged = data => {
  if (data !== undefined) {
    let owner = ''
    data.forEach((value, index) => {
      owner += value += ' '
    })
    emit('real-estate-owner', owner)
  }
}

const loadUserBilling = () => {
  axios
    .get('/api/user/billing')
    .then(response => {
      dataUserBilling.value = response.data
    })
    .catch(err => {
      console.log('loadUserBilling error: ' + err)
    })
}

const initRealEstateData = () => {
  realEstateGeneral.value = {
    kinnistu_registriosa_number: '',
    kinnistu_kinnistusosakond: '',
    kinnistu_liik: '',
    kinnistu_nr: '',
    kinnistu_korteriyhistu_registrikood: '',
    kinnistu_oigsuse_marge: '',
    kinnistu_digitaalne_toimik: '',
    kinnistu_kuupaev: '',
  }
}
</script>
